(function () {
  'use strict';
  class Controller {
    constructor() {}
    $count(obj) {
      let total = 0;
      angular.forEach(obj, () => {
        total++;
      });
      return total;
    }
  }
  angular
    .module('display.list', [])
    .component('displayList', {
      controller: Controller,
      templateUrl: 'root/display/list/list-display.route.html'
    })
    .config(function ($stateProvider) {
      $stateProvider
        .state('display.list', {
          abstract: false,
          url: '/list',
          template: '<display-list/>'
        });
    });
}());
